import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelGroupFilterSettings } from '../entities/articles/artikelgroupfiltersettings.entity';
import { ArtikelGroup } from '../entities/articles/artikelgroup.entity';
import { Group } from '../entities/schema/group.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class ArtikelGroupFilterSettingsService extends ODataEntityService<ArtikelGroupFilterSettings> {
  constructor(protected client: ODataClient) {
    super(client, 'ArtikelGroupFilterSettings', 'entities.articles.ArtikelGroupFilterSettings');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public artikelliste(entity: EntityKey<ArtikelGroupFilterSettings>): ODataNavigationPropertyResource<ArtikelGroup> {
    return this.entity(entity).navigationProperty<ArtikelGroup>('artikelliste');
  }
  public group(entity: EntityKey<ArtikelGroupFilterSettings>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<ArtikelGroupFilterSettings>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ArtikelGroupFilterSettings>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
